// 优惠券折扣逻辑
const discountRules = [
  { min: 469, discount: 120, code: "TR120", type: "fixed" },
  { min: 349, discount: 80, code: "TR80", type: "fixed" },
  { min: 249, discount: 50, code: "TR50", type: "fixed" },
  // 新增百分比折扣优惠券示例
  { min: 50, discount: 16, code: "TR16", type: "percent" },
  { min: 0, discount: 0, code: "", type: "fixed" },
];

// 特价商品列表（不能使用优惠券的产品ID）
const specialPriceProducts = [
  // 在这里添加特价商品的ID（确保是整数）
  8181663301814, 8185515016374, 8182174318774, 8186391560374, 8161225572534,
  8137161375926, 8113940857014, 8109821952182, 8109821132982, 8109820412086,
  8094236541110, 8039945699510, 8038568689846, 8017395384502, 8014929166518,
  7644140503222, 6801818747062, 8038568689846, 8167174504630, 8186391560374,
  8141312786614, 8139442389174, 8131853484214, 8131834314934, 8113962713270,
  8094235787446, 8073745957046, 8061459005622, 8061254926518, 8026507083958,
  8016354050230, 8016321609910, 7999668453558, 7720565178550, 7679966806198,
  7647921701046, 7647110824118, 7604425195702, 7586292891830, 7584725237942,
  7583540314294, 7580747890870, 7580746416310, 7580446359734, 6956879675574,
  8188150808758, 7712252690614, 8113957535926, 8178262966454, 7351043883190,
  7758628094134, 7621152407734, 7728718872758, 7497830924470, 7609746718902,
  7738867876022, 7743567626422, 7642803601590, 7746660925622, 7753262301366, 
  7742179246262, 7759043264694, 7783675199670, 7785417670838,
  7788828917942, 7818243473590, 7903511314614, 7821575913654,8192916750518,
  7753339633846, 7753337634998, 7753334456502, 7753324003510,7750776651958,
  7660662161590, 7660323831990, 7660214190262, 7658588340406,8195686924470,
  8195686072502, 7731604947126, 7953469046966,
];

// 计算Deal Price
function calculateDealPrice(price, productId) {
  // 将价格从美分转换为美元
  const priceInDollars = price / 100;

  // 检查是否是特价商品
  if (specialPriceProducts.includes(parseInt(productId))) {
    console.log("特价产品检测到:", productId);
    return price; // 特价产品直接返回原价
  }

  // 找到适用的折扣规则
  const rule = discountRules.find((rule) => priceInDollars >= rule.min);
  if (rule) {
    if (rule.type === "percent") {
      // 百分比折扣：计算折扣金额并从原价中减去
      const discountAmount = Math.round(price * (rule.discount / 100));
      return price - discountAmount;
    } else {
      // 固定金额折扣
      return price - rule.discount * 100; // 将折扣从美元转换为美分
    }
  }

  return price;
}

// 更新价格显示
function updatePriceDisplay(variant, productId) {
  if (!variant) return;

  const price = variant.price;
  const comparePrice = variant.compare_at_price;

  console.log(
    "更新价格显示:",
    productId,
    "是否特价产品:",
    specialPriceProducts.includes(parseInt(productId))
  );

  // 更新常规价格
  const priceElement = document.querySelector(
    `.ProductPrice-${productId} .money`
  );
  if (priceElement) {
    priceElement.setAttribute("data-currency-usd", formatMoney(price));
    priceElement.textContent = formatMoney(price, true);
  }

  // 更新比较价格
  const comparePriceElement = document.querySelector(
    `.ComparePrice-${productId} .money`
  );
  if (comparePriceElement && comparePrice > price) {
    comparePriceElement.setAttribute(
      "data-currency-usd",
      formatMoney(comparePrice)
    );
    comparePriceElement.textContent = formatMoney(comparePrice, true);
    comparePriceElement.parentElement.style.display = "flex";
  } else if (comparePriceElement) {
    comparePriceElement.parentElement.style.display = "none";
  }

  // 计算并更新Deal Price
  const dealPrice = calculateDealPrice(price, productId);
  console.log(
    "计算的Deal Price:",
    formatMoney(dealPrice, true),
    "原价:",
    formatMoney(price, true)
  );

  // 更新所有Deal Price元素（包括固定底部的）
  const dealPriceElements = document.querySelectorAll(
    `.DealPrice-${productId} .money`
  );
  dealPriceElements.forEach(function (element) {
    element.setAttribute("data-currency-usd", formatMoney(dealPrice));
    element.textContent = formatMoney(dealPrice, true);
  });

  // 更新所有分期付款价格
  const afterpayElements = document.querySelectorAll(
    ".new-price-afterpay .money"
  );
  afterpayElements.forEach(function (element) {
    const weeklyPayment = Math.round(dealPrice / 4);
    element.setAttribute("data-currency-usd", formatMoney(weeklyPayment));
    element.textContent = formatMoney(weeklyPayment, true);
  });
}

// 格式化金额
function formatMoney(cents, withSymbol = false) {
  const dollars = cents / 100;
  const formatted = dollars.toFixed(2);
  return withSymbol ? `$${formatted}` : formatted;
}

// 创建折扣信息弹窗
function createDiscountInfoPopup() {
  const popup = document.createElement("div");
  popup.className = "discount-info-popup";
  popup.innerHTML = `
    <div class="discount-info-popup-close">&times;</div>
    <div class="discount-info-popup-title">Discount Details</div>
    <div class="discount-info-popup-content">
      <div class="discount-info-popup-item">
        <span>Original Price:</span>
        <span class="original-price"></span>
      </div>
      <div class="discount-info-popup-item">
        <span>Coupon Discount:</span>
        <span class="coupon-discount"></span>
      </div>
      <div class="discount-info-popup-total">
        <span>Deal Price:</span>
        <span class="final-price"></span>
      </div>
    </div>
  `;

  // 关闭弹窗
  popup
    .querySelector(".discount-info-popup-close")
    .addEventListener("click", function () {
      popup.classList.remove("active");
    });

  return popup;
}

// 修改showDiscountInfo函数，支持显示百分比折扣信息
function showDiscountInfo(price, productId, clickedElement) {
  let popup = document.querySelector(".discount-info-popup");
  const buttonContainer = clickedElement.closest(".payment-buttons-wrapper");
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  // 如果弹窗不存在，创建一个新的
  if (!popup) {
    popup = createDiscountInfoPopup();
  }

  // 移除之前的弹窗
  const oldPopup = document.querySelector(".discount-info-popup");
  if (oldPopup) {
    oldPopup.remove();
  }

  // 创建新弹窗
  popup = createDiscountInfoPopup();

  // 移动端和PC端不同的弹窗位置处理
  if (isMobile) {
    // 移动端：弹窗添加到body并显示在底部
    document.body.appendChild(popup);
    popup.classList.add("mobile-popup");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        popup.classList.add("active");
      });
    });
  } else {
    // PC端：弹窗显示在按钮上方
    buttonContainer.style.position = "relative";
    buttonContainer.appendChild(popup);
  }

  // 将价格从美分转换为美元进行比较
  const priceInDollars = price / 100;

  // 检查是否是特价商品
  if (specialPriceProducts.includes(parseInt(productId))) {
    console.log("折扣信息弹窗 - 特价产品:", productId);
    popup.querySelector(".discount-info-popup-content").innerHTML = `
      <div style="text-align: center; padding: 10px 0;">
        You're getting the best deal—no code required. Just enjoy your purchase!
      </div>
    `;
  } else {
    // 找到适用的折扣规则
    const rule = discountRules.find((rule) => priceInDollars >= rule.min);
    let discount = 0;
    let discountText = "";

    if (rule) {
      if (rule.type === "percent") {
        // 百分比折扣
        discount = Math.round(price * (rule.discount / 100));
        discountText =
          formatMoney(discount, true) +
          (rule.code ? ` (${rule.discount}% Off, Code: ${rule.code})` : "");
      } else {
        // 固定金额折扣
        discount = rule.discount * 100; // 将折扣从美元转换为美分
        discountText =
          formatMoney(discount, true) +
          (rule.code ? ` (Code: ${rule.code})` : "");
      }
    }

    const finalPrice = price - discount;

    popup.querySelector(".original-price").textContent = formatMoney(
      price,
      true
    );
    popup.querySelector(".coupon-discount").textContent = discountText;
    popup.querySelector(".final-price").textContent = formatMoney(
      finalPrice,
      true
    );
  }

  popup.classList.add("active");

  // 添加点击外部关闭弹窗
  setTimeout(function () {
    document.addEventListener("click", closePopupOnOutsideClick);
  }, 10);

  function closePopupOnOutsideClick(e) {
    if (!popup.contains(e.target) && !clickedElement.contains(e.target)) {
      popup.classList.remove("active");
      document.removeEventListener("click", closePopupOnOutsideClick);
    }
  }
}

// 添加关闭弹窗的函数
function closeDiscountPopup() {
  const popup = document.querySelector(".discount-info-popup.active");
  if (popup) {
    popup.classList.remove("active");
  }
}

// 处理动态按钮的显示
function fixDynamicButtons() {
  // 处理原始按钮区域
  const paymentButton = document.querySelector(".shopify-payment-button");
  if (paymentButton) {
    // 移除额外的支付选项文本
    const morePaymentOptions = paymentButton.querySelector(
      ".shopify-payment-button__more-options"
    );
    if (morePaymentOptions) {
      morePaymentOptions.style.display = "none";
    }

    // 确保PayPal按钮正确显示
    const paypalButton = paymentButton.querySelector(
      ".shopify-payment-button__button--branded"
    );
    if (paypalButton) {
      paypalButton.style.minHeight = "44px";
      paypalButton.style.height = "44px";
    }

    // 确保普通Buy Now按钮正确显示
    const buyNowButton = paymentButton.querySelector(
      ".shopify-payment-button__button--unbranded"
    );
    if (buyNowButton) {
      buyNowButton.style.minHeight = "44px";
      buyNowButton.style.height = "44px";
    }
  }
}

// 初始化
document.addEventListener("DOMContentLoaded", function () {
  // 绑定折扣信息点击事件
  const discountInfoBtns = document.querySelectorAll(".hide-discode-info");
  discountInfoBtns.forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      event.stopPropagation(); // 阻止事件冒泡
      const productId = parseInt(
        btn.closest("[data-product-id]").getAttribute("data-product-id")
      );
      const priceElement = document.querySelector(
        ".ProductPrice-" + productId + " .money"
      );
      const price = priceElement
        ? parseFloat(priceElement.getAttribute("data-currency-usd")) * 100
        : 0;
      showDiscountInfo(price, productId, this);
    });
  });

  // 修复动态按钮显示
  fixDynamicButtons();

  // 初始更新价格
  const productForm = document.querySelector(".product-single__form");
  if (productForm) {
    const productId = productForm.querySelector('[name="product-id"]').value;
    const variantJson = document.querySelector("[data-variant-json]");
    if (variantJson) {
      const variants = JSON.parse(variantJson.textContent);
      const currentVariantJson = document.querySelector(
        "[data-current-variant-json]"
      );
      const currentVariant = currentVariantJson
        ? JSON.parse(currentVariantJson.textContent)
        : variants[0];
      updatePriceDisplay(currentVariant, productId);
    }
  }

  // 监听变体变化
  document.addEventListener("variant:change", function (e) {
    if (e.detail && e.detail.variant) {
      const variant = e.detail.variant;
      const productId = document
        .querySelector("[data-product-id]")
        .getAttribute("data-product-id");
      updatePriceDisplay(variant, productId);
    }
  });
});

// 与现有的_updatePrice函数集成
const originalUpdatePrice =
  window.theme &&
  window.theme.Product &&
  window.theme.Product.prototype._updatePrice;
if (originalUpdatePrice) {
  window.theme.Product.prototype._updatePrice = function (variant) {
    originalUpdatePrice.call(this, variant);

    // 额外更新我们的自定义价格显示
    const productId = this.container.getAttribute("data-product-id");
    if (productId) {
      updatePriceDisplay(variant, productId);
    }
  };
}